
  import CSVDownload from '@/components/common/download-csv'
  import DailyForm from '@/components/daily/form'
  import DailyEditForm from '@/components/daily/edit'
  import Tasks from '@/components/todo/tasks';

  export default {
    mixins: [],
    components: {
      'm-csv-btn': CSVDownload,
      'm-daily-form': DailyForm,
      'm-daily-edit-form': DailyEditForm,
      'm-tasks': Tasks
    },
    data () {
      return {
        form: {},
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        search: '',
        pagination: {},
        selectedItem: {},
        visited: false,
        marked: false,
        headers: [
          { width: '15', text: 'Date', value: 'date' },
          { width: '15', text: 'Time', value: 'time' },
          { text: 'Report', value: 'report' },
          { width: '20', text: 'Actions', value: 'actions' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        this.sendForm(data);
        this.dialog = false;
      },
      onClose (data) {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getDataDaily();
      },
      inValidItem (item) {
        return !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email_address));
      },
      onUpdate (data) {
        console.log('save update daily: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/daily', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.reset();
          this.getDataDaily();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        this.updateDaily(data);
      },
      updateDaily (data, cb) {
        // var app = this;
        var id = this.selectedItem.id;
        console.log('updateForm', data);
        this.$http
        .put('api/daily/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          if (cb) {
            cb();
          } else {
            this.getDataDaily();
          }
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$http
        .delete('api/daily/' + item.id)
        .then(response => {
          console.log('daily deleted', response.data);
          this.getDataDaily();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getData () {
        this.getDataDaily();
      },
      getDataDaily () {
        var app = this;
        this.$http
        .get('service/daily/getLimited')
        .then(response => {
          // console.log('data', response.data);
          app.items = response.data;
          app.items.map(function (r) {
            r.date = app.$options.filters.date(r.date)
          })
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    }
  }
